<header>
    <!-- Angular Router auxiliary outlet for header -->
    <router-outlet name="header"></router-outlet>
    <!-- Conditionally show header based on route and user context (for non-outlet routes) -->
    <!-- Use CSS display instead of *ngIf to prevent component destruction during navigation -->
    <app-unified-header [style.display]="(showUnifiedHeader$ | async) ? 'block' : 'none'"></app-unified-header>
    <app-public-header-black-logo [style.display]="(showPublicHeader$ | async) ? 'block' : 'none'"></app-public-header-black-logo>
    <!-- Use null (not 'block') when shown so the component's own :host { display: flex } applies; an
         inline 'block' would override it and collapse the logo / sign-in row layout. -->
    <app-signup-header [style.display]="(showSignupHeader$ | async) ? null : 'none'"></app-signup-header>
</header>

<app-toast></app-toast>

<div class="app-container">
    <nav class="side-rail-container">
        <!-- Angular Router auxiliary outlet for side rail -->
        <router-outlet name="sideRail"></router-outlet>
        <!-- Show side rail only after user context loads to prevent authorization directive issues (for non-outlet routes) -->
        <app-side-rail *ngIf="showSideRail$ | async"></app-side-rail>
    </nav>

    <main class="main-content" role="main">
        <!-- Navigation spinner: shown while the router resolves a navigation (guards, resolvers,
             user context loading) so deep-links/refreshes of protected routes don't show a blank page. -->
        <app-wait *ngIf="showNavigationSpinner$ | async" class="navigation-spinner" waitText="Please wait..."></app-wait>

        <!-- Primary router outlet for main content -->
        <router-outlet></router-outlet>

        <!-- Auxiliary outlets for multi-outlet routes (workflows, etc.) -->
        <router-outlet name="content"></router-outlet>

        <!-- Auxiliary outlets for nested content areas -->
        <router-outlet name="entityContent"></router-outlet>
        <router-outlet name="network-content"></router-outlet>
        <router-outlet name="carrierProfileContent"></router-outlet>
        <router-outlet name="agencyProfileContent"></router-outlet>
    </main>
</div>

<app-overlay></app-overlay>

<footer>
    <!-- Angular Router auxiliary outlet for footer -->
    <router-outlet name="footer"></router-outlet>
    <!-- Static footer for non-outlet routes. Hidden on multi-outlet routes (workflows, popups like
         finraU4Popup) that render their own footer@ outlet, so it isn't shown on top of theirs. -->
    <app-footer *ngIf="showFooter$ | async"></app-footer>
</footer>

<app-dialog dialogId="browser-unsupported-dialog" heading="Your Browser is Not Supported">
    <ng-template>
        <app-browser-unsupported></app-browser-unsupported>
    </ng-template>
</app-dialog>

<app-dialog dialogId="session-management-dialog" heading="Your Session is About to End" closable="false">
    <ng-template>
        <app-session-management></app-session-management>
    </ng-template>
</app-dialog>

<app-dialog dialogId="reauth-dialog" heading="Verify Your Identity" closable="false">
    <ng-template>
        <app-re-auth
            (verified)="closeReAuthDialog()"
            (cancelled)="closeReAuthDialog()">
        </app-re-auth>
    </ng-template>
</app-dialog>
